module.exports = __webpack_public_path__ + "static/media/share-icon-open.697d8d00.svg";